import { render, staticRenderFns } from "./EditBeneficiaryTemplates.vue?vue&type=template&id=23135dce&"
import script from "./EditBeneficiaryTemplates.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiaryTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports